import { DatePicker } from "antd";
import { DeliveredNotCollected } from "./components/Finance/DeliveredNotCollected"
import { PaidOrders } from "./components/Finance/PaidOrders"
import { useContext } from "react";
import { OrdersContext } from "../../context/OrdersContext";
import { TableOrdersFinance } from "./components/Finance/TableOrdersFinance";

const { RangePicker } = DatePicker;
const dateFormat = "DD-MM-YYYY";

export const BoardFinance = () => {
    const {
        filteredOrdersByEnd,
        dateFilter,
        setDateFilter,
      } = useContext(OrdersContext);
      
    return (
        <div className="w-11/12 mx-auto my-6">
                <div className="mr-5 w-full pb-4 text-end">
                    <RangePicker
                    value={dateFilter}
                    onChange={(dates) => setDateFilter(dates)}
                    format={dateFormat}
                    />
                </div>
                <div className="mb-5">
                    <TableOrdersFinance data={filteredOrdersByEnd}/>
                </div>
                <div className="mb-5">
                    <DeliveredNotCollected data={filteredOrdersByEnd}/>
                </div>
                <div className="mb-5">
                    <PaidOrders filteredOrdersByEnd={filteredOrdersByEnd}/>
                </div>
            </div>
        )
}